import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import FamiliarForm from './FamiliarForm';
import { showFamiliarApi, updateFamiliarApi, clearEditedFamiliar } from './familiarSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import uploadImage from '~/api/uploadImage';
import { pictureAttributeNames } from './initialValue';

function FamiliarUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.heroSaga.familiar);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'familiars');
        dispatch(updateFamiliarApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showFamiliarApi({ navigate, id }));

        return () => dispatch(clearEditedFamiliar());
    }, []);

    return (
        <FamiliarForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default FamiliarUpdate;
